import { Outlet, Navigate, useLocation } from 'react-router-dom';

const AuthGuard = () => {
    const location = useLocation();
    localStorage.setItem('path', location.pathname);
    const hasToken = !!localStorage.getItem('userKey');
    return hasToken ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
};

export default AuthGuard;
